<template>
  <div style="width: 100%;overflow: hidden" @click="handleClick">
    <!--    第一层-->
    <div class="div2-MAU">
      <a class="div2-a1-MAU">
        <a class="div2-a2-MAU"><strong>Products Center / 产品中心</strong></a>
        <br>
        致力于畜禽无害化处理设备与废气、废水处理设备、粪便处理设备的研发与生产
        <br>
      </a>
    </div>

    <!--    第二层：视频简介-->
    <div class="div2-mpc">
      <div class="div2-div1-mpc">
        <!--          muted:静音 autoplay:自动播放-->
        <video ref="videoPlayer" muted autoplay controls style="border-radius:15px;width: 100%" @ended="restartVideo">
          <source :src="productVideo" type="video/mp4">
        </video>
      </div>
    </div>

    <!--第三层：产品内容-->
    <div class="div3-mpc">
      <div class="div3-div1-mpc">
        畜禽无害化智能处理机
      </div>
      <div class="div3-div2-mpc">
        <img :src="productImg" title="畜禽无害化智能处理机" width="100%">
      </div>
      <div class="div3-div3-mpc">
        &#12288;&#12288;畜禽无害化智能处理机,对病死畜禽及其制品主要采取干化法分类进行无害化处理，通过高温裂解，将病原体完全杀灭，并使油脂融化和蛋白质凝固，经化制后的油脂可用于工业用油；肉骨粉可用于有机肥料加工的原材料。<br>
        &#12288;&#12288;生产过程中产生的废气，经配套处理后达到国家排放标准，确保无废水、无废气、无废渣，杜绝二次污染源的产生，并达到零排放；保证畜产品质量的安全及人民群众的身体健康，是畜禽无害化处理的优质产品！
      </div>
    </div>

    <!--    第四层：质量保证-->
    <div class="div2-MAU">
      <a class="div2-a1-MAU">
        <a class="div2-a2-MAU" style="color: darkorchid"><strong>Quality Assurance/ 质量保证</strong></a>
        <br>
        可靠的质量 &#12288;用心的服务
        <br>
      </a>
    </div>

    <!--    第五层：质量保证内容-->
    <div class="div3-mpc">
      <div class="div3-div2-mpc">
        <img :src="qualityImg" width="100%">
      </div>
      <div class="div3-div1-mpc">
        本公司为广大用户郑重承诺
      </div>
      <div class="div3-div3-mpc">
        一、将以最短时间、最快速度、到达现场，全天候服务于用户<br>
        &#12288;&#12288;&#12288;浙江省内24小时到达现场；<br>
        &#12288;&#12288;&#12288;浙江省外30小时到达现场。<br>
        二、实行跟踪服务<br>
        三、为用户免费提供技术培训<br>
      </div>
    </div>

    <!--    第八层：底框-->
    <div class="div9-MFP">
      <div class="div9-div1-MFP">
        <a class="div9-a1-MFP">联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
        <a class="div9-a1-MFP">联系方式：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
        <a class="div9-a1-MFP">邮箱：{{this.$store.state.contactIntroduce.email}}</a><br>
        <a class="div9-a1-MFP">地址：{{this.$store.state.contactIntroduce.address}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a class="div9-a2-MFP" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
        <a class="div9-a2-MFP" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a style="font-family: Avenir">Copyright © 2024</a><br>
        <a>版权所有©浙江纵海自动化设备有限公司</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
      </div>
    </div>

  </div>
</template>

<script>
  import '../css/mobile/MPC_MobileProductCenter.css'

  export default {
    name: "MobileProductCenter",
    data() {
      return {
        //质量保证图片
        qualityImg: require('../../public/image/质量保证.jpg'),
        //产品视频
        productVideo: require('../../public/video/产品介绍.mp4'),
        //产品图片
        productImg: require('../../public/image/首页图片1.jpg'),
      }
    },
    methods: {
      handleClick() {
        let that = this;
        if(that.$store.state.isShowNav==true){
          that.$store.state.isShowNav = false;
        }
        // if (that.$store.state.isShowNav == true) {
        //   setTimeout(function () {
        //     that.$store.state.isShowNav = false;
        //     console.log("延迟1s");
        //   }, 100);
        // }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/MobileProductCenter.vue